export default __webpack_public_path__ + "static/chrome-15d17cf05fe42d055145c8ee679bc0a4.png";